import { render, staticRenderFns } from "./BadgeListProductGroup.vue?vue&type=template&id=35516bc2&"
import script from "./BadgeListProductGroup.vue?vue&type=script&lang=js&"
export * from "./BadgeListProductGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35516bc2')) {
      api.createRecord('35516bc2', component.options)
    } else {
      api.reload('35516bc2', component.options)
    }
    module.hot.accept("./BadgeListProductGroup.vue?vue&type=template&id=35516bc2&", function () {
      api.rerender('35516bc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Badges/BadgeListProductGroup.vue"
export default component.exports